import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import {AppTooltipPosition} from "./tooltip.directive";
import {MediaService} from "../../../../media/media.service";
import {RendererService} from "../../../../renderer";

@Component({
    selector: 'div[app-tooltip]',
    imports: [],
    template: '',
    styleUrl: './tooltip.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': '[baseClass, baseClass + "--" + position]',
        '[style.right]': 'right ? right + "px" : "unset"',
        '[style.left]': 'left ? left + "px" : "unset"',
        '[style.top]': 'top ? top + "px" : "unset"',
        '[style.bottom]': 'bottom ? bottom + "px" : "unset"',
        '[style.hidden]': 'media.isUnderMd || disabled',
    }
})
export class TooltipComponent implements OnInit, OnChanges {
  public media = inject(MediaService)
  private elRef = inject(ElementRef<HTMLDivElement>);
  private renderer = inject(RendererService);
  public readonly baseClass = 'app-tooltip';

  @Input() tooltip: string = '';
  @Input() left?: number;
  @Input() top?: number;
  @Input() bottom?: number;
  @Input() right?: number;
  @Input() position: AppTooltipPosition = 'below';
  @Input() disabled: boolean = false;

  ngOnInit(): void {
    this.renderer.renderHtml(this.elRef.nativeElement, this.tooltip);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['content']) {
      this.renderer.renderHtml(this.elRef.nativeElement, this.tooltip);
    }
  }
}
